module.exports = {
  fieldsNeeded: ['device_type'],
  match: function(visitorProfile, cond) {
    return visitorProfile.device_type === cond.value;
  },
};
